module.exports = "/default/images/vendor/lightgallery.js/dist/video-play.png?4f03bd8dec67211ade8abdab39dcbf4a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightgallery.js/dist/img/video-play.png
// module id = +Z62
// module chunks = 0